import { LoadingIcon } from 'morpheus-ui';
import { Button } from '../../../../core/components/atoms/Button';
import { useGetPracticeAreas } from '../../hooks/getPracticeAreas';
import { Fragment, useEffect, useState } from 'react';
import { Select, iOption } from '../../../../core/components/atoms/Select';
import {
  IAreaFilter,
  ICompleteFilter,
  practiceConfigStore,
} from '../../stores/practiceConfigStore';
import { OptionsFormater } from '../../../../core/utils/dataTools';
import MultipleSelect from '../../../../core/components/atoms/MultipleSelect';

export function DisciplineSection() {
  const { data, isLoading } = useGetPracticeAreas();
  const { setAreasFilter, areasFilter } = practiceConfigStore();

  const [areas, setAreas] = useState<iOption[]>([]);

  useEffect(() => {
    if (data) {
      const areas = data.areas;
      const allAreas = areas.map((it) => {
        return {
          value: it.id,
          label: it.title,
        };
      });

      setAreas(allAreas);
    }
  }, [data]);

  const onSelectArea = (area: string) => {
    const selected = data?.areas.find((it) => it.id === area);

    const subareas = selected?.subareas;

    const newArray = OptionsFormater(subareas || []);
    return newArray;
  };

  const onSelectModule = (modules: string[], area: string) => {
    const selectArea = data?.areas.find((it) => it.id === area);

    const selectModule = selectArea?.subareas.filter((it) =>
      modules.includes(it.id)
    );

    let subjects: { title: string; id: string }[] = [];
    selectModule?.map((modulo) => {
      subjects = [...subjects, ...modulo.subjects];
    });

    const newArray = OptionsFormater(subjects);
    return newArray;
  };

  const formatSelectedArea = (area: string) => {
    if (area) {
      const areaSelected = data?.areas.find((item) => item.id === area);

      return {
        label: areaSelected?.title || '',
        value: areaSelected?.id || '',
      };
    }

    return { label: '', value: '' };
  };

  const add = () => {
    const aux = [...areasFilter];

    aux.push({
      area: '',
      subareas: [],
      subjects: [],
    });

    setAreasFilter(aux);
  };

  const handleChangeArray = (
    array: Partial<IAreaFilter>[],
    idx: number,
    area?: string,
    subarea?: string[],
    subject?: string[]
  ) => {
    if (array.length > 0) {
      const newArray = array.map((it, i) => {
        if (i === idx) {
          return {
            area: area ? area : it.area,
            subareas: area ? [] : subarea ? subarea : it.subareas,
            subjects: area ? [] : subject ? subject : it.subjects,
          };
        } else {
          return it;
        }
      });

      return newArray;
    }

    return [];
  };

  const newArea = (type: string, idx: number, value: any) => {
    const aux = [...areasFilter];

    if (type === 'area') {
      const updatedAux = handleChangeArray(
        aux,
        idx,
        value,
        undefined,
        undefined
      );
      setAreasFilter(updatedAux as ICompleteFilter);
    }

    if (type === 'modulo') {
      const updatedAux = handleChangeArray(
        aux,
        idx,
        undefined,
        value,
        undefined
      );
      setAreasFilter(updatedAux as ICompleteFilter);
    }

    if (type === 'subject') {
      const updatedAux = handleChangeArray(
        aux,
        idx,
        undefined,
        undefined,
        value
      );
      setAreasFilter(updatedAux as ICompleteFilter);
    }
  };

  const removeDiscipline = (idx: number) => {
    const reusableArray = [...areasFilter];

    const updated = reusableArray.filter((__, i) => i !== idx);

    if (idx === 0) {
      updated.push({ area: '', subareas: [], subjects: [] });
    }

    setAreasFilter(updated);
  };

  const areaObjectBuild = (it: Partial<IAreaFilter>) => {
    return {
      areaSelected: formatSelectedArea(it.area || ''),
      areas: areas,
      modules: onSelectArea(it.area || ''),
      subjects: onSelectModule(it.subareas || [], it.area || ''),
    };
  };

  return (
    <Fragment>
      {isLoading || !data ? (
        <LoadingIcon className='stroke-current h-12 animate-spin fill-none text-center' />
      ) : (
        <div className='mt-1 flex flex-col gap-xl'>
          {areasFilter.length > 0 &&
            areasFilter.map((it: Partial<IAreaFilter>, i: number) => {
              const areaAdded = areaObjectBuild(it);
              const allSelectedAreas = areasFilter.map((area) => area.area);

              return (
                <div
                  className='flex flex-col items-center gap-xxl rounded-md border-hairline border-mono-color-dark p-4'
                  key={i}
                >
                  <Select
                    options={areaAdded.areas.filter(
                      (area) =>
                        !allSelectedAreas.includes(area.value.toString())
                    )}
                    label='Disciplinas'
                    onChange={(value) => newArea('area', i, value.value)}
                    value={areaAdded.areaSelected}
                  />
                  {areaAdded.modules.length > 0 && (
                    <MultipleSelect
                      label='Módulos'
                      options={areaAdded.modules || []}
                      selected={it.subareas || []}
                      onChange={(value) => newArea('modulo', i, value)}
                    />
                  )}
                  {areaAdded.subjects.length > 0 && (
                    <MultipleSelect
                      label='Assuntos'
                      options={areaAdded.subjects}
                      selected={it.subjects || []}
                      onChange={(value) => newArea('subject', i, value)}
                    />
                  )}
                  <div className='flex w-full flex-row justify-end'>
                    <Button
                      variant='text'
                      iconType='material'
                      LeftIcon='add'
                      iconVariant='rounded'
                      onClick={() => add()}
                    >
                      Adicionar disciplina
                    </Button>
                    <Button
                      variant='text'
                      iconType='material'
                      LeftIcon='delete'
                      iconVariant='rounded'
                      className='w-fit p-0 text-feedback-color-error-pure'
                      onClick={() => removeDiscipline(i)}
                    >
                      Excluir conteúdos
                    </Button>
                  </div>
                </div>
              );
            })}
        </div>
      )}
    </Fragment>
  );
}
